import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import CustomerHome from "@/pages/CustomerHome";
import RestaurantPage from "@/pages/RestaurantPage";
import CartPage from "@/pages/CartPage";
import OrderConfirm from "@/pages/OrderConfirm";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerProfile from "@/pages/CustomerProfile";
import InvoicePage from "@/pages/InvoicePage";

import RestaurantLogin from "@/pages/restaurant/RestaurantLogin";
import Dashboard from "@/pages/restaurant/Dashboard";
import LiveOrders from "@/pages/restaurant/LiveOrders";
import KDS from "@/pages/restaurant/KDS";
import MenuManager from "@/pages/restaurant/MenuManager";
import PageTabsManager from "@/pages/restaurant/PageTabsManager";
import ReviewsManager from "@/pages/restaurant/ReviewsManager";
import OffersManager from "@/pages/restaurant/OffersManager";
import Analytics from "@/pages/restaurant/Analytics";
import TableManager from "@/pages/restaurant/TableManager";
import Loyalty from "@/pages/restaurant/Loyalty";
import RestaurantSettings from "@/pages/restaurant/RestaurantSettings";
import CustomCharges from "@/pages/restaurant/CustomCharges";
import Customers from "@/pages/restaurant/Customers";
import OrderHistory from "@/pages/restaurant/OrderHistory";

import BusinessHome from "@/pages/business/BusinessHome";
import BusinessFeatures from "@/pages/business/BusinessFeatures";
import BusinessPricing from "@/pages/business/BusinessPricing";
import BusinessDemo from "@/pages/business/BusinessDemo";
import BusinessDemoConfirmed from "@/pages/business/BusinessDemoConfirmed";
import BusinessHowItWorks from "@/pages/business/BusinessHowItWorks";
import BusinessContact from "@/pages/business/BusinessContact";

import AdminPanel from "@/pages/admin/AdminPanel";

const RootDispatcher = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (params.get("open") === "admin") return <AdminPanel />;
  if (params.get("r")) return <RestaurantPage />;
  return <BusinessHome />;
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-center" richColors />
      <Routes>
        <Route path="/" element={<RootDispatcher />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/order-confirm" element={<OrderConfirm />} />
        <Route path="/invoice" element={<InvoicePage />} />
        <Route path="/login" element={<CustomerLogin />} />
        <Route path="/profile" element={<CustomerProfile />} />

        {/* Restaurant operator */}
        <Route path="/restaurant/login" element={<RestaurantLogin />} />
        <Route path="/restaurant/dashboard" element={<Dashboard />} />
        <Route path="/restaurant/orders" element={<LiveOrders />} />
        <Route path="/restaurant/kitchen" element={<KDS />} />
        <Route path="/restaurant/menu" element={<MenuManager />} />
        <Route path="/restaurant/page-tabs" element={<PageTabsManager />} />
        <Route path="/restaurant/reviews" element={<ReviewsManager />} />
        <Route path="/restaurant/offers" element={<OffersManager />} />
        <Route path="/restaurant/analytics" element={<Analytics />} />
        <Route path="/restaurant/tables" element={<TableManager />} />
        <Route path="/restaurant/loyalty" element={<Loyalty />} />
        <Route path="/restaurant/settings" element={<RestaurantSettings />} />
        <Route path="/restaurant/charges" element={<CustomCharges />} />
        <Route path="/restaurant/customers" element={<Customers />} />
        <Route path="/restaurant/order-history" element={<OrderHistory />} />

        {/* Marketing */}
        <Route path="/business" element={<BusinessHome />} />
        <Route path="/business/features" element={<BusinessFeatures />} />
        <Route path="/business/pricing" element={<BusinessPricing />} />
        <Route path="/business/how-it-works" element={<BusinessHowItWorks />} />
        <Route path="/business/demo" element={<BusinessDemo />} />
        <Route path="/business/demo-confirmed" element={<BusinessDemoConfirmed />} />
        <Route path="/business/contact" element={<BusinessContact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
